(function(global) {

    'use strict';

    function configure(cfg) {
        for (var p in DSerialLoader.defaultConfig) {
            if (!(p in cfg)) {
                cfg[p] = DSerialLoader.defaultConfig[p];
            }
        }
        return cfg;
    }

    /* Class for loading scripts in serial - useful when a script file requires (depends on) another script file */
    function DSerialLoader(urls, cfg, win) {
        this.urls = urls || [];
        this.config = configure(cfg || {});
        this.resolve = null;
        this.reject = null;
        this.doc = (win || global).document;
        this.fetchedUrls = [];
        this.eventListeners = {};
    }

    DSerialLoader.defaultConfig = {
        typeValue: 'application/javascript',
        parentTagName: 'head'
    };

    DSerialLoader.prototype.resolveUrl = function(url) {
        this.fetchedUrls.push(url);
        if (this.urls.length) {
            this.loadScript(this.urls.shift());
        } else {
            this.resolve(this.fetchedUrls);
            this.resolve = null;
            this.reject = null;
        }
    };

    DSerialLoader.prototype.onLoad = function(url, e) {
        this.removeEventListeners(e.target); // must remove event listeners before fetching next script
        this.resolveUrl(url);
    };

    DSerialLoader.prototype.onError = function(url, e) {
        this.removeEventListeners(e.target);
        this.reject(new Error('Url \'' + url + '\' not found!'));
        this.resolve = null;
        this.reject = null;
    };

    DSerialLoader.prototype.removeEventListeners = function(el) {
        ['load', 'error'].forEach(function(s) {
            el.removeEventListener(s, this.eventListeners[s], false);
            delete this.eventListeners[s];
        }.bind(this));
    };

    // note that the script element is inserted into the DOM
    DSerialLoader.prototype.loadScript = function(url) {
        // check if already loaded (inserted into DOM)
        if (this.doc.querySelector('script[src="' + url + '"]')) {
            this.resolveUrl(url);
            return;
        }
        var parentTagName = (this.config.parentTagName || 'head').toLowerCase();
        var parentElement = this.doc.querySelector(parentTagName);
        var scr = this.doc.createElement('script');
        scr.setAttribute('charset', this.config.charset || 'UTF-8');
        scr.setAttribute('type', this.config.typeValue  || 'application/javascript');
        if(this.config.typedValue === 'module') {
            scr.removeAttribute('noModule');
        }
        // scr.setAttribute('async', 'async'); // defaults to true in most browsers when SCRIPT element is created by a script
        var onLoad = this.onLoad.bind(this, url);
        this.eventListeners['load'] = onLoad;
        scr.addEventListener('load', onLoad, false);
        var onError = this.onError.bind(this, url);
        this.eventListeners['error'] = onError;
        scr.addEventListener('error', onError, false);
        parentElement.appendChild(scr);
        scr.setAttribute('src', url);
    };

    DSerialLoader.prototype.require = function(urls) {
        return new Promise(function(resolve, reject) {
            this.resolve = resolve;
            this.reject = reject;
            if (urls && urls.length) {
                Array.prototype.push.apply(this.urls, urls);
            }
            if (this.urls.length) {
                this.loadScript(this.urls.shift());
            } else {
                this.resolve([]);
            }
        }.bind(this));
    };

    global.DSerialLoader = DSerialLoader;

    if(typeof module !== 'undefined' && module.exports) {
        module.exports = DSerialLoader;
    }

})(window);